// import { UserDataT } from "@/types/auth";
import { create } from "zustand";
import Axios from "../lib/Axios";

const useSkillListStore = create((set) => ({
  skillList: [],
  skillListSelectCompatiable: [],
  fetchSkill: async () => {
    try {
      const result = await Axios.post("/cms/cms-get/skill-name");
      const data = result?.data?.result?.results?.map((item) => {
        return { label: item.skillName, value: item.skillId, ...item };
      });
      set((state) => ({
        skillList: result?.data?.result?.results,
        skillListSelectCompatiable: data,
      }));
    } catch (error) {}
  },
}));

export default useSkillListStore;
